<template lang="html">
  <div>
    <div class="sorobancolumn">
      <div class="stick"></div>
      <div
        id="five"
        class="bead bead-five"
        :class="{down: fivebeadDown}"
        @click="moveFifthbead"
      >
      <Bead beadtype='heavenly'/>
      </div>

      <div class="selector"></div>

      <div class="ones">

        <div id="one"
          @click="moveFirstbead"
          :class="{up:onebeadUp}"
          class="bead bead-one"
        >
        <Bead />
        </div>

        <div id="two"
          @click="moveSecondbead"
          :class="{up:twobeadUp}"
          class="bead bead-one"
        >
        <Bead />
        </div>

        <div id="three"
          @click="moveThirdbead"
          class="bead bead-one"
          :class="{up:threebeadUp}"
        >
        <Bead />
        </div>

        <div id="four"
          @click="moveFourthbead"
          class="bead bead-one"
          :class="{up:fourbeadUp}"
        >
        <Bead />
        </div>

      </div>
    </div>

    <div class="result" :class="{'d-none': !showResult}">
      {{result}}
    </div>
  </div>
</template>

<script>
import Bead from './Bead.vue';

export default {
  props: ['digit', 'ID', 'clickDisabled', 'showResult'],
  data(){
    return{
    }
  },
  methods:{
    moveFirstbead(){
      if (!this.clickDisabled) {
          this.$emit('firstbeadClicked', {digit: this.result, id : this.ID, status: this.onebeadUp})
      }
    },
    moveSecondbead(){
      if (!this.clickDisabled) {
        this.$emit('secondbeadClicked', {digit: this.result, id : this.ID, status: this.twobeadUp})
      }
    },
    moveThirdbead(){
      if (!this.clickDisabled) {
        this.$emit('thirdbeadClicked', {digit: this.result, id : this.ID, status: this.threebeadUp})
      }
    },
    moveFourthbead(){
      if (!this.clickDisabled) {
        this.$emit('fourthbeadClicked', {digit: this.result, id : this.ID, status: this.fourbeadUp})
      }
    },
    moveFifthbead(){
      if (!this.clickDisabled) {
        this.$emit('fifthbeadClicked', {digit: this.result, id : this.ID, status: this.fivebeadDown})
      }
    },
  },
  computed:{
    result(){
      let res = 0;
      if (this.fivebeadDown) {
        res+=5;
      }
      if (this.onebeadUp) {
        res+=1;
      }
      if (this.twobeadUp) {
        res+=1;
      }
      if (this.threebeadUp) {
        res+=1;
      }
      if (this.fourbeadUp) {
        res+=1;
      }
      return res
    },
    fivebeadDown(){
      if (this.digit>=5) {
        return true;
      }
      return false;
    },
    onebeadUp(){
      if(this.digit==1 || this.digit==2 || this.digit==3 ||this.digit==4 ||this.digit==6||this.digit==7||this.digit==8||this.digit==9){
        return true;
      }
      return false;
    },
    twobeadUp(){
      if(this.digit==2 || this.digit==3 ||this.digit==4 ||this.digit==7||this.digit==8||this.digit==9){
        return true;
      }
      return false;
    },
    threebeadUp(){
      if(this.digit==3 ||this.digit==4 ||this.digit==8||this.digit==9){
        return true;
      }
      return false;
    },
    fourbeadUp(){
      if(this.digit==4 || this.digit==9){
        return true;
      }
      return false;
    },
  },
  components:{
    Bead,
  },
}
</script>

<style lang="scss" scoped>
.sorobancolumn{
  width: 60px;
  height: 300px;
  background-color: inherit;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @media(max-width:600px){
    width: 30px;
    height: 210px;
  }

  .stick{
    transform: rotateY(180deg);
    width: 3px;
    height: 300px;
    background-color: brown;
    position: absolute;

    @media(max-width:600px){
      height: 210px;
    }
  }
}

.selector{
  height: 6px;
  width: 100%;
  background-color: #8B4513;
}

.bead{
  transition: 0.5s all ease-out;
}
.bead-five.down{
  transform: translateY(46px);
  transition: 0.5s all ease-out;

  @media(max-width:600px){
    transform: translateY(32px);
  }
}

.bead-one.up{
  transform: translateY(-46px);
  transition: 0.5s all ease-out;

  @media(max-width:600px){
    transform: translateY(-32px);
  }
}

.result{
  width: 60px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-size: 30px;

  @media(max-width:600px){
    width: 30px;
  }
}

</style>
